export default "__VITE_ASSET__Cd$OYfeV__"